import { ApiRoutes, QueryError } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { SearchConsoleAccount, SearchConsoleAccountOTPFields, SearchConsoleAccountsOTPQueryKeys } from '@/modules/DomainsApi';

export const useGetSearchConsoleAccountOTPQuery = (id: string) =>
  buildQuery<string, QueryError>([SearchConsoleAccountsOTPQueryKeys.GetCode, id], async () => {
    const { data } = await apiExecutor.get<string>(
      ApiRoutes.DomainsApiSearchConsoleAccountOTP.replace(':searchConsoleAccountId', id)
    );
    return data;
  });

export const useAddSearchConsoleAccountOTPMutation = (id: string) =>
  buildMutation<
    {
      isOtpSetted: boolean;
      otpAuthenticator?: Pick<NonNullable<SearchConsoleAccount['otpAuthenticator']>, 'period'>
    },
    QueryError,
    SearchConsoleAccountOTPFields
  >(
    [SearchConsoleAccountsOTPQueryKeys.Add],
    async (postData) => {
      const { data } = await apiExecutor.post(ApiRoutes.DomainsApiSearchConsoleAccountOTP.replace(':searchConsoleAccountId', id), {
        ...postData
      });
      return data;
    }
  );

export const useRemoveSearchConsoleAccountOTPMutation = (id: string) =>
  buildMutation<void, QueryError, void>(
    [SearchConsoleAccountsOTPQueryKeys.Delete],
    async () => {
      await apiExecutor.delete(ApiRoutes.DomainsApiSearchConsoleAccountOTP.replace(':searchConsoleAccountId', id));
    }
  );
